import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import clsx from 'clsx';
import Placeholder from './Placeholder.jsx';
import styles from './ObservationItem.module.css';

function ObservationItem({label, icon, primaryValues = [], primaryValueLabels = [], unit = false}) {
  return (
    <div className={styles.ObservationItem} >
      <div className={styles.ObservationIconBox}>
        <FontAwesomeIcon icon={icon} className={styles.ObservationIcon} size="2xl" />
      </div>
      <div className={styles.ObservationTextArea}>
        <h6 className={styles.ObservationTitle}>{label}</h6>
        <div className={styles.MultiPrimaryValueWrapper}>
          {primaryValues.map((primaryValue, index) => (
            <div className={styles.PrimaryValue} key={index}>
              {primaryValueLabels[index] && <span className={styles.MultiPrimaryStatLabel}>{primaryValueLabels[index]}</span>}
              <Placeholder ready={primaryValue} xs={6}>
              <span className={styles.PrimaryStat}>
                {Number.isFinite(primaryValue) ? primaryValue.toFixed(1) : primaryValue}
              </span>
                {unit !== false && <span className={styles.PrimaryUnit}>&nbsp;{unit}</span>}
              </Placeholder>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ObservationItem;
